import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: 240,
            flexShrink: 0,
        },
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: '18px',
    },
    drawerPaper: {
        width: 240,
        padding: '18px',
    },
    logoSidebar: {
        width: '70%',
    },
    closeMenuButton: {
        marginRight: 'auto',
        marginLeft: 0,

        [theme.breakpoints.down('md')]: {
            marginRight: 0,
        },
    },
}));
